import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { environment } from 'environments/environment';
import { filter } from 'rxjs';
import { MetricsService } from './metrics.service';

type Payload = {
    [key: string]: unknown
}

declare function gtag(command: string, ...args: unknown[]): void;

@Injectable()
export class GoogleAnalyticsService extends MetricsService {

    private router = inject(Router);
    private appService = inject(AppService);

    private uuidPattern: RegExp = new RegExp('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}', 'g');

    constructor() {
        super();
        this.capturePageViews(this.router);
    }

    private capturePageViews(router: Router) {
        router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.capture('page_view', this.currentLocation(event.urlAfterRedirects));
        });
    }

    capture(eventName: string, payload: Payload): void {
        // each event has to have a user_id and user_client_id
        if (environment?.metrics) {
            try {
                gtag('event', eventName,
                    {
                        user_id: this.appService?.user?.id,
                        user_client_id: this.appService?.client?.id,
                        ...this.currentLocation(this.router.url),
                        ...payload
                    }
                );
            } catch (error) {
                console.error(error);
            }
        }
    }

    exception(payload: Payload): void {
        if (environment?.metrics) {
            try {
                gtag('event', 'exception', payload);
            } catch (error) {
                console.error(error);
            }
        }
    }

    reset(): void {
        throw new Error('Method not implemented.');
    }


    private currentLocation(url: string): { page_location: string, sanitised_url: string} {
        const sanitisedUrl = url.replace(this.uuidPattern, '-');
        return {
            page_location: url,
            sanitised_url: sanitisedUrl
        }
    }
}
